var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Popover } from '@mui/material';
import UserRecentNotificationsPopoverContent from './UserRecentNotificationsPopoverContent';
var UserRecentNotificationsPopover = function (_a) {
    var open = _a.open, anchorEl = _a.anchorEl, onClose = _a.onClose;
    return (_jsx(Popover, __assign({ open: open, anchorEl: anchorEl, onClose: onClose, anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left'
        }, transformOrigin: {
            vertical: 'top',
            horizontal: 'center'
        } }, { children: _jsx(UserRecentNotificationsPopoverContent, { handleMenuClose: onClose }, void 0) }), void 0));
};
export default UserRecentNotificationsPopover;
